import { render, staticRenderFns } from "./Imtiyozlilar.vue?vue&type=template&id=3d854dfe&scoped=true"
import script from "./Imtiyozlilar.vue?vue&type=script&lang=js"
export * from "./Imtiyozlilar.vue?vue&type=script&lang=js"
import style0 from "./Imtiyozlilar.vue?vue&type=style&index=0&id=3d854dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d854dfe",
  null
  
)

export default component.exports